module.exports = __webpack_public_path__ + "img/hcpasuransilainnya.26a03255.svg";